// extracted by mini-css-extract-plugin
export default {"container":"AudioPresentational_container__W0mgb","speaker":"AudioPresentational_speaker__gS-Ew","text":"AudioPresentational_text__-f-6o"};